@if (form) {
  <form [formGroup]="form">
    <label>{{ 'ONBOARDING_CHANGE_COUNTRY_LABEL' | translate }}</label>
    <em-select formControlName="country">
      <em-option>--</em-option>
      @for (country of countries$ | async; track country) {
        <em-option [value]="country">
          <div class="option-content">
            <em-country-flag
              class="mr-4"
              [size]="'lg'"
              [countryCode]="country"
            ></em-country-flag>
            <div class="label">{{ 'COUNTRY_' + country | translate }}</div>
          </div>
        </em-option>
      }
      @if (form?.controls.country.hasError('required')) {
        <em-error>{{
          'VALIDATION_FIELD_REQUIRED' | translate
        }}</em-error>
      }
    </em-select>
  </form>
}
